export const getters = {
	optionsForMenu: (state) =>
		state.categories.map((item) => ({ id: item.id, name: item.name })),
	getParents: (state) => state.categories.filter((cat) => !cat.parent_id),
	orderedCategories: (state) => {
		//get the categories and order them by parent -> child
		const dataset = state.categories
		const hashTable = Object.create(null)
		dataset.forEach(
			(aData) => (hashTable[aData.id] = { ...aData, childNodes: [] })
		)
		const dataTree = []
		dataset.forEach((aData) => {
			if (aData.parent_id) {
				hashTable[aData.parent_id].childNodes.push(hashTable[aData.id])
			} else dataTree.push(hashTable[aData.id])
		})

		let returnMenu = []
		dataTree.forEach((item) => {
			returnMenu.push(item)
			if (item.childNodes.length > 0) {
				returnMenu = [...returnMenu, ...item.childNodes]
			}
		})
		return returnMenu
	},
}
